import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { FormServiceFieldTechnicalDefinitionsLayout } from "../table";
import { useI18n } from "../../../../../../../contexts";
import { isUrl, isHost } from "@devowl-wp/react-utils";
import { Notices } from "../../../../../../common";
const FormServiceFieldTechnicalDefinitionsCookieHost = (param)=>{
    let { field, readOnly } = param;
    const { __, _i } = useI18n();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(Form.Item, {
            noStyle: true,
            shouldUpdate: (prevValues, nextValues)=>{
                var _prevValues_technicalDefinitions_field_name, _nextValues_technicalDefinitions_field_name, _prevValues_technicalDefinitions_field_name1, _nextValues_technicalDefinitions_field_name1;
                return ((_prevValues_technicalDefinitions_field_name = prevValues.technicalDefinitions[field.name]) == null ? void 0 : _prevValues_technicalDefinitions_field_name.type) !== ((_nextValues_technicalDefinitions_field_name = nextValues.technicalDefinitions[field.name]) == null ? void 0 : _nextValues_technicalDefinitions_field_name.type) || ((_prevValues_technicalDefinitions_field_name1 = prevValues.technicalDefinitions[field.name]) == null ? void 0 : _prevValues_technicalDefinitions_field_name1.host) !== ((_nextValues_technicalDefinitions_field_name1 = nextValues.technicalDefinitions[field.name]) == null ? void 0 : _nextValues_technicalDefinitions_field_name1.host);
            },
            children: (param)=>{
                let { getFieldValue } = param;
                const type = getFieldValue([
                    "technicalDefinitions",
                    field.name,
                    "type"
                ]);
                const host = getFieldValue([
                    "technicalDefinitions",
                    field.name,
                    "host"
                ]);
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Form.Item, {
                            ...FormServiceFieldTechnicalDefinitionsLayout,
                            name: [
                                field.name,
                                "host"
                            ],
                            rules: [
                                {
                                    validator: (_, value)=>([
                                            "local",
                                            "session",
                                            "indexedDb"
                                        ].indexOf(type) > -1 ? isUrl(value) : isHost(value)) || value === "" && type !== "http" ? Promise.resolve() : Promise.reject(__("Please provide a valid hostname!"))
                                }
                            ],
                            dependencies: [
                                [
                                    "technicalDefinitions",
                                    field.name,
                                    "type"
                                ]
                            ],
                            children: /*#__PURE__*/ _jsx(Input, {
                                disabled: readOnly
                            })
                        }),
                        host.startsWith("*.") && host.length > 2 && /*#__PURE__*/ _jsx(Notices, {
                            notices: [
                                {
                                    message: _i(__("You are using an invalid wildcard (placeholder) syntax {{code}}*.{{/code}} to match subdomains. Use {{code}}.%s{{/code}} to include subdomains.", host.substr(2)), {
                                        code: /*#__PURE__*/ _jsx("code", {})
                                    }),
                                    severity: "warning"
                                }
                            ]
                        })
                    ]
                });
            }
        })
    });
};
export { FormServiceFieldTechnicalDefinitionsCookieHost };
